import React from "react";
import "./International.css";
export const InternationalT = () => {
  const matchOdds = [
    {
      team: "Bangladesh",
      back: ["1.36", "1.37", "1.38"],
      lay: ["1.39", "1.41", "1.42"],
      volume: ["6.5K", "2K", "256.34", "3.4K", "4.6K", "2.1K"],
    },
    {
      team: "Ireland",
      back: ["3.4", "3.45", "3.5"],
      lay: ["3.6", "3.7", "3.75"],
      volume: ["360.49", "2.3K", "823.72", "1.2K", "1.9K", "899.27"],
    },
  ];

  return (
    <div className="container betfair-ui">
      {/* Header */}
      <div className="section-header">
        <span className="title">Match Odds</span>
        <span className="cash-out">🟡 Cash Out</span>
        <span className="matched">Matched € 21.7K</span>
      </div>

      {/* Table */}
      <table className="odds-table">
        <tbody>
          <tr>
            <td className="team">Bangladesh</td>
            <td className="back back-1">
              1.36
              <br />
              <small>6.5K</small>
            </td>
            <td className="back back-2">
              1.37
              <br />
              <small>2K</small>
            </td>
            <td className="back back-3">
              1.38
              <br />
              <small>256.3</small>
            </td>
            <td className="lay lay-1">
              1.4
              <br />
              <small>3.4K</small>
            </td>
            <td className="lay lay-2">
              1.41
              <br />
              <small>4.6K</small>
            </td>
            <td className="lay lay-3">
              1.42
              <br />
              <small>2.1K</small>
            </td>
          </tr>

          <tr>
            <td className="team">Ireland</td>
            <td className="back back-1">
              3.4
              <br />
              <small>360.49</small>
            </td>
            <td className="back back-2">
              3.45
              <br />
              <small>2.3K</small>
            </td>
            <td className="back back-3">
              3.5
              <br />
              <small>823.7</small>
            </td>
            <td className="lay lay-1">
              3.6
              <br />
              <small>1.2K</small>
            </td>
            <td className="lay lay-2">
              3.7
              <br />
              <small>1.9K</small>
            </td>
            <td className="lay lay-3">
              3.75
              <br />
              <small>899.2</small>
            </td>
          </tr>
        </tbody>
      </table>

      {/* Suspended Section */}
      <div className="section-header">
        <span className="title">Tied Match</span>
        <span className="cash-out">🟡 Cash Out</span>
      </div>

      <div className="suspended-box">
        <h2>SUSPENDED</h2>
      </div>
    </div>
  );
};
